import { BUSINESS_MODELS } from "@shared/constants";

export function getIsPreconfigAvailable(status, businessModel, isCashJourney) {
  if (!Array.isArray(status)) {
    return status;
  }

  let idx = 0;

  if (businessModel === BUSINESS_MODELS.B2B) {
    idx += 2;
  }

  if (!isCashJourney) {
    idx++;
  }

  return status[idx];
}
